import { X } from '@phosphor-icons/react'
import { ComponentProps, forwardRef, MouseEventHandler } from 'react'

import { FORMULAS } from '@/components/CalculationComponent/constants'
import cn from '@/utils/tailwind/cn'

import { DropdownInfoModel } from '../..'
import { Dropdown } from '../Dropdown'

type Props = ComponentProps<typeof Dropdown.Root> & {
  onClose: MouseEventHandler<HTMLButtonElement>
  dropdownInfo?: DropdownInfoModel
  onSelectItem: (key?: string) => void
}

export const FunctionDropdown = forwardRef<HTMLDivElement, Props>(
  ({ className, dropdownInfo, onClose, onSelectItem, ...props }, ref) => (
    <Dropdown.Root
      className={cn(dropdownInfo?.dataType === 'insertHTMLFunction' && 'block')}
      ref={ref}
      {...props}
    >
      <Dropdown.CloseButton onClick={onClose}>
        <X className="text-xs text-white" weight="bold" />
      </Dropdown.CloseButton>
      <Dropdown.List>
        {FORMULAS.filter((value) => value.key === 'countifs').map(
          ({ key, value, description, formula }) => (
            <Dropdown.ListItem key={key}>
              <Dropdown.ListItemButton
                disabled={dropdownInfo?.currentFunction === key}
                onClick={() => onSelectItem(key)}
              >
                <span className="text-gray-800">{value}</span>
                <span className="info hidden text-xs font-medium text-gray-500">
                  {description}
                </span>
                <span className="info hidden text-xs font-medium text-gray-500">
                  {formula}
                </span>
              </Dropdown.ListItemButton>
            </Dropdown.ListItem>
          )
        )}
      </Dropdown.List>
      <Dropdown.Footer>
        Click on the name to select the function
      </Dropdown.Footer>
    </Dropdown.Root>
  )
)
